import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { ErrorStore, StridesStoreItem } from '@sleipai/sleip-models';
import {
  State,
  analysisStridesesFeatureKey,
  selectAllAnalysisStridesAdapter,
} from '../reducers/analysis-strides.reducer';

export const selectAnalysisStridesStoreState = createFeatureSelector<State>(
  analysisStridesesFeatureKey
);

export const isLoaded = (state: State): boolean => state.loaded;
export const isLoading = (state: State): boolean => state.loading;
export const AnalysisStridesError = (state: State): ErrorStore | null =>
  state.error;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectAnalysisStridesStoreState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectAnalysisStridesStoreState,
  isLoaded
);

export const selectAnalysisStridesError: MemoizedSelector<
  object,
  ErrorStore | null
> = createSelector(selectAnalysisStridesStoreState, AnalysisStridesError);

export const selectAllAnalysisStrides = createSelector(
  selectAnalysisStridesStoreState,
  selectAllAnalysisStridesAdapter
);

export const selectAnalysisStridesById = (id: string) =>
  createSelector(
    selectAllAnalysisStrides,
    (analysisStrides: StridesStoreItem[]) => {
      if (analysisStrides) {
        return (
          analysisStrides.find(
            (SharedAnalysisResult) => SharedAnalysisResult.id === id
          ) ?? null
        );
      } else {
        return null;
      }
    }
  );

export const selectMultipleAnalysisStridesByIds = (ids: string[]) =>
  createSelector(
    selectAllAnalysisStrides,
    (stridesStoreItems: StridesStoreItem[]) => {
      if (stridesStoreItems) {
        const filteredStridesStoreItems = stridesStoreItems.filter(({ id }) => {
          return ids.indexOf(id ?? '') != -1;
        });

        return filteredStridesStoreItems;
      } else {
        return null;
      }
    }
  );
